import React from 'react'
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'

// 引入Home组件
const Home = React.lazy(()=>import('../views/home/Home'))
const Error = React.lazy(()=>import('../views/404/Error404'))
const UserAgreement = React.lazy(()=>import('../views/home/textInfo/UserAgreement'))
const TermsofUser = React.lazy(()=>import('../views/home/textInfo/TermsofUser'))
const privacyChildren = React.lazy(()=>import('../views/home/textInfo/PrivacyChildren'))

export default function IndexRouter() {
  return (
    <Router>
        <Switch>
            <Route path="/home" component={Home} />
            <Route path="/userAgreement" component={UserAgreement} />
            <Route path="/termsofUser" component={TermsofUser} />
            <Route path="/privacyChildren" component={privacyChildren} />
            <Redirect from="/" to="/home/layout" exact/>

            <Route component={Error} />
        </Switch>
    </Router>
  )
}
